import { DatePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { UiCardComponent } from '@app/shared/ui/card/ui-card.component';
import { formatTime } from '@app/shared/utils/time-utils';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * ReportSummaryComponent - presentation-only summary card built on the DS `proffeo-ui-card`.
 *
 * Contains no calculation logic: callers pass already-computed values and optional preformatted
 * label strings (period/time/break/type). Minutes are formatted for display only. Optional rows
 * are hidden when their input is empty. An optional created-by footer is shown when
 * `createdByName` is set.
 *
 * @selector proffeo-report-summary
 */
@Component({
  selector: 'proffeo-report-summary',
  templateUrl: './report-summary.component.html',
  imports: [DatePipe, UiCardComponent, TranslatePipe]
})
export class ReportSummaryComponent {
  protected readonly durationPerDayLabel = computed(() => formatTime(Math.max(0, this.durationPerDayMinutes()) * 60));
  protected readonly totalLabel = computed(() => formatTime(Math.max(0, this.totalMinutes()) * 60));

  /** @summary Optional creator display name shown in the footer. */
  public readonly createdByName = input<string>('');

  /** @summary Optional creation timestamp shown under the creator. */
  public readonly createdAt = input<Date | null>(null);

  /** @summary Optional report date formatted with the application locale. */
  public readonly date = input<Date | null>(null);

  /** @summary Optional translated mode label key. */
  public readonly modeLabelKey = input<string>('');

  /** @summary Optional selected project display label. */
  public readonly projectLabel = input<string>('');

  /** @summary Optional selected task display label. */
  public readonly taskLabel = input<string>('');

  /** @summary Optional selected location display label. */
  public readonly locationLabel = input<string>('');

  public readonly periodLabel = input<string>('');
  public readonly timeLabel = input<string>('');
  public readonly breakLabel = input<string>('');
  public readonly typeLabel = input<string>('');
  public readonly perDayLabelKey = input<string>('time-reports.report-entry.summary-per-day');
  public readonly days = input<number>(0);
  public readonly durationPerDayMinutes = input<number>(0);
  public readonly totalMinutes = input<number>(0);
}
